module.exports = __webpack_public_path__ + "static/img/more-LOGO-01.ac47ef7a.svg";